import { Address, CustomerCustomField, PaymentMethod, PhoneNumber } from 'types/formData';

const voidAddressObject: Address = {
    address: '',
    buildingNumber: '',
    city: '',
    zip: '',
    province: '',
    country: '',
};

const voidPhoneNumberObject: PhoneNumber = {
    prefix: '',
    number: '',
};

const voidContactObject = {
    phoneNumber: voidPhoneNumberObject,
    email: '',
    accountingDocsEmail: '',
    managerEmail: '',
    pecCompany: '',
};

const voidExemptionLetter = {
    attachments: [],
};

const voidInvoice = {
    splitPayment: false,
    pec: '',
    sdi: '',
    cig: '',
    cup: '',
    companyGroup: '',
    regularExporter: false,
    regularExporterCheck: false,
    internationalSubject72: false,
    csvRecap: false,
    exemptionLetter: voidExemptionLetter,
};

const voidPaymentData: PaymentMethod = {
    paymentMethodId: -999,
    paymentData: null,
    countryCode: '',
    currencyCode: '',
};

const generateVoidCustomField = (position: number, name = '', collapsed = true): CustomerCustomField => {
    return {
        name: name,
        customName: '',
        mandatory: false,
        validityCheck: false,
        meaningful: false,
        origin: 'P',
        dividedInCostCentre: false,
        visibleInBilling: false,
        position: position,
        collapsed: collapsed,
        attachments: null,
    };
};

export const voidCustomField = {
    name: '',
    customName: '',
    mandatory: false,
    validityCheck: false,
    meaningful: false,
    origin: 'P',
    visibleInBilling: false,
    position: 0,
};

export const voidCustomerForm = {
    entityType: -1,
    entityTarget: -1,
    pa: false,
    companyName: '',
    vat: '',
    taxIdCode: '',
    supplierNation: '',
    countryTax: '',
    legalAddress: voidAddressObject,
    contact: voidContactObject,
    vatGroup: '',
    invoice: voidInvoice,
    airPaymentMethods: voidPaymentData,
    notAirPaymentMethods: voidPaymentData,
    field_suggestion: '',
    applicantName: '',
    applicantSurname: '',
    applicantEmail: '',
    customFields: [
        generateVoidCustomField(0, 'Matricola', false),
        generateVoidCustomField(0, 'Centro di costo', false),
        generateVoidCustomField(1),
        generateVoidCustomField(2),
        generateVoidCustomField(3),
        generateVoidCustomField(4, 'Campo CIG', true),
        generateVoidCustomField(5, 'Campo CUP', true),
        generateVoidCustomField(6),
        generateVoidCustomField(7),
        generateVoidCustomField(8),
        generateVoidCustomField(9),
        generateVoidCustomField(10),
    ],
    validations: {
        vatValidations: [],
        taxIdCodeValidations: [],
        pecValidations: [],
    },
    specialCustomsArrangements: false,
};
